import React from "react"
import { Link } from "gatsby"

import MainLayout from "../../components/layout"
import SEO from "../../components/seo"
import "bootstrap/dist/css/bootstrap.min.css"

import Intro from "../../components/SubPages/IntroSubPages/introSubPages"
import GridView from "../../components/SubPages/GridViewSubPages/gridViewSubPages"
import CurrentSystem from "../../components/SubPages/ServicesPage/ServiceCurrentSystem/serviceCurrentSystem"
import Carousel from "../../components/SubPages/CarouselSubPages/carouselSubPages"
import BlueBar from "../../components/SubPages/SolutionsPage/BlueBar/blueBar"

import Img from "../../images/products/meet.png"
import AwsIcon from "../../images/solutions/serverless/AWS Lambda.png"
import ArchitechIcon from "../../images/solutions/serverless/architecture.png"
import CertifiedIcon from "../../images/solutions/serverless/Certified engineers.png"

import mockImg from "../../images/realtime/Serverless.svg"

import CarouselImg1 from "../../images/solutions/serverless/Meetrix teach.png"

import Constants from "../../constants/solutions.json"

const carouselData = [
  {
    description:
      Constants.SOLUTIONS.servelessSolutions.carouselData.i1.description,
    img: CarouselImg1,
  },
]

const GridData = [
  {
    title: Constants.SOLUTIONS.servelessSolutions.GridDataArray.i1.title,
    description:
      Constants.SOLUTIONS.servelessSolutions.GridDataArray.i1.description,
    img: AwsIcon,
  },
  {
    title: Constants.SOLUTIONS.servelessSolutions.GridDataArray.i2.title,
    description:
      Constants.SOLUTIONS.servelessSolutions.GridDataArray.i2.description,
    img: ArchitechIcon,
  },
  {
    title: Constants.SOLUTIONS.servelessSolutions.GridDataArray.i3.title,
    description:
      Constants.SOLUTIONS.servelessSolutions.GridDataArray.i3.description,
    img: CertifiedIcon,
  },
]

const ServerlessSolutions = () => (
  <MainLayout>
    <SEO
      title="Serverless Solutions"
      description="With more and more platforms moving their services to serverless, cloud providers have been improving their services for going serverless.
            Build a Serverless Web Application with AWS Lambda, Amazon API Gateway, Amazon S3, Amazon DynamoDB, and Amazon Cognito."
      pagePath="/solutions/serverless-solutions"
      schema={`{
              "@context": "https://meetrix.io/solutions/serverless-solutions",
              "@type": "WebPage",
              "mainEntity": {
                "@type": "Organization",
                "name": "Meetrix.io",
              }
            }`}
    />
    <Intro
      title={Constants.SOLUTIONS.servelessSolutions.MainLayout.title}
      description={
        Constants.SOLUTIONS.servelessSolutions.MainLayout.description
      }
      blueTitle={Constants.SOLUTIONS.servelessSolutions.MainLayout.blueTitle}
      blueLink=""
      background={mockImg}
    />
    <GridView
      noButton
      title={Constants.SOLUTIONS.servelessSolutions.GridView.title}
      description={Constants.SOLUTIONS.servelessSolutions.GridView.description}
      bottomTitle={Constants.SOLUTIONS.servelessSolutions.GridView.bottomTitle}
      data={GridData}
      linkTitle={Constants.SOLUTIONS.servelessSolutions.GridView.linkTitle}
    />
    <BlueBar
      title={Constants.SOLUTIONS.servelessSolutions.blueRow.i1.title}
      description={
        Constants.SOLUTIONS.servelessSolutions.blueRow.i1.description
      }
    />
    <Carousel data={carouselData} />
  </MainLayout>
)

export default ServerlessSolutions
